import { render, staticRenderFns } from "./MenuActionsComponent.vue?vue&type=template&id=538cc174&"
import script from "./MenuActionsComponent.vue?vue&type=script&lang=js&"
export * from "./MenuActionsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports